import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'syn-no-selected-filter',
    templateUrl: 'no-selected-filter.html',
    styleUrls: ['no-selected-filter.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoSelectedFilterComponent {
    constructor() { }
}
